import React from 'react';
import OnboardingLayout from '../OnboardingLayout';
import { Box, Button, Typography, Stack, Chip } from '@mui/material';
import LaunchIcon from '@mui/icons-material/Launch';
import shiftworksAiLogo from '../../../assets/shiftworks-ai.png';
import saveTimeIcon from '../../../assets/SaveTime.SVG';
import lightbulbIcon from '../../../assets/lightbulb.svg';
import teamCheckIcon from '../../../assets/TeamCheck.svg';

export default function StepWelcome({ onNext }) {
  return (
    <OnboardingLayout>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 3 }}>
        <Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                <Box sx={{ width: 88, height: 88, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <img src={shiftworksAiLogo} alt="Shiftworks AI" style={{ height: 72, width: 'auto', display: 'block', borderRadius: 10 }} />
                </Box>
            <Box>
              <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 700, letterSpacing: 0.6 }}>SHIFTWORKS</Typography>
              <Typography variant="h6" sx={{ fontWeight: 700 }}>Onboarding</Typography>
            </Box>
          </Box>
        </Box>

        <Typography variant="body2" sx={{ color: 'text.secondary' }}>Step 0 of 5</Typography>
      </Box>

      <Box sx={{ mb: 3 }}>
        <Typography variant="h3" sx={{ fontWeight: 800, mb: 1 }}>Welcome to Shiftworks</Typography>
        <Typography variant="body1" sx={{ color: 'text.secondary', maxWidth: 800 }}>Let's set up locations, hours, and your team in minutes. You can start fresh or import what you have—either way, we'll guide you.</Typography>
      </Box>

      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} sx={{ mb: 4 }}>
  <Button variant="contained" color="primary" onClick={onNext} sx={{ px: 4, py: 1.5, boxShadow: '0 6px 18px rgba(15,23,42,0.12)', borderRadius: 3, '&:hover': { boxShadow: '0 8px 22px rgba(15,23,42,0.14)' } }}>
          Get started&nbsp;&nbsp;<LaunchIcon fontSize="small" />
        </Button>
  <Button variant="outlined" sx={{ px: 3, py: 1.5, bgcolor: 'rgba(255,255,255,0.85)', borderRadius: 3, '&:hover': { boxShadow: '0 6px 18px rgba(15,23,42,0.06)' } }}>
          Import from CSV or 7shifts
        </Button>
      </Stack>

      <Stack direction={{ xs: 'column', md: 'row' }} spacing={2} sx={{ mb: 4 }}>
        <Box sx={{ flex: 1 }}>
          <Box sx={{ p: 2, borderRadius: 3, bgcolor: 'rgba(240,246,255,0.95)', backdropFilter: 'blur(2px)', boxShadow: '0 6px 18px rgba(16,24,40,0.06)', display: 'flex', gap: 2, alignItems: 'center' }}>
            <Box sx={{ width: 112, height: 112, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <img src={saveTimeIcon} alt="save time" style={{ width: 88, height: 88, display: 'block' }} />
            </Box>
            <Box>
              <Typography variant="subtitle1" sx={{ fontWeight: 900, color: 'text.primary' }}>Minutes, not hours</Typography>
              <Typography variant="body2" sx={{ color: 'text.secondary' }}>Guided steps that keep momentum—save your progress anytime.</Typography>
            </Box>
          </Box>
        </Box>

        <Box sx={{ flex: 1 }}>
          <Box sx={{ p: 2, borderRadius: 3, bgcolor: 'rgba(240,246,255,0.95)', backdropFilter: 'blur(2px)', boxShadow: '0 6px 18px rgba(16,24,40,0.06)', display: 'flex', gap: 2, alignItems: 'center' }}>
            <Box sx={{ width: 112, height: 112, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <img src={lightbulbIcon} alt="smart defaults" style={{ width: 88, height: 88, display: 'block' }} />
            </Box>
            <Box>
              <Typography variant="subtitle1" sx={{ fontWeight: 900, color: 'text.primary' }}>Smart defaults</Typography>
              <Typography variant="body2" sx={{ color: 'text.secondary' }}>Pre-filled templates for roles, shift types, and labor rules.</Typography>
            </Box>
          </Box>
        </Box>

        <Box sx={{ flex: 1 }}>
          <Box sx={{ p: 2, borderRadius: 3, bgcolor: 'rgba(240,246,255,0.95)', backdropFilter: 'blur(2px)', boxShadow: '0 6px 18px rgba(16,24,40,0.06)', display: 'flex', gap: 2, alignItems: 'center' }}>
            <Box sx={{ width: 112, height: 112, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <img src={teamCheckIcon} alt="team check" style={{ width: 88, height: 88, display: 'block' }} />
            </Box>
            <Box>
              <Typography variant="subtitle1" sx={{ fontWeight: 900, color: 'text.primary' }}>Seamless import</Typography>
              <Typography variant="body2" sx={{ color: 'text.secondary' }}>Bring existing teams and schedules with one upload.</Typography>
            </Box>
          </Box>
        </Box>
      </Stack>

      <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', mt: 2, flexWrap: 'wrap' }}>
        <Chip label="No credit card to start" variant="outlined" sx={{ bgcolor: 'rgba(255,255,255,0.85)' }} />
        <Chip label="SOC2 in progress" variant="outlined" sx={{ bgcolor: 'rgba(255,255,255,0.85)' }} />
        <Chip label="24/7 email support" variant="outlined" sx={{ bgcolor: 'rgba(255,255,255,0.85)' }} />
      </Box>
    </OnboardingLayout>
  );
}
